import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  "aria-live": "polite",
  "aria-atomic": "true",
  class: "fixed-top sc-general-info"
}
const _hoisted_2 = { class: "toast-container position-absolute top-0 end-0 p-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_toast = _resolveComponent("base-toast")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notifications, (item) => {
        return (_openBlock(), _createBlock(_component_base_toast, {
          key: item.id,
          alert: item
        }, null, 8, ["alert"]))
      }), 128))
    ])
  ]))
}